module.exports = __webpack_public_path__ + "img/title.f980b4f3.png";